define('lq/events/actions/languageCommand',[
    'jquery',
    'lq/queryString',
    'lq/events/actions/eventAction',
    'lq/runtimeUrl'
], function ($, queryString, EventAction, RuntimeUrl) {
    'use strict';

    function LanguageCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(LanguageCommand, EventAction);

    LanguageCommand.typeName = 'LanguageCommand';

    LanguageCommand.prototype.getBatchType = function () {
        return this.eventData.refreshPage
            ? EventAction.DO_NOT_BATCH
            : EventAction.COMMAND_BATCH;
    };

    LanguageCommand.prototype.createEventActionRequest = function () {
        return {
            eventActionType: 'SwitchLanguage',
            commandId: this.eventData.command
        };
    };

    LanguageCommand.prototype.execute = function (continuation, eventActionResponse) {
        if (eventActionResponse.QueryString)
            this.piping.url.overwriteLicquidParameter(RuntimeUrl.parameters.language, eventActionResponse.QueryString);
        this.refreshPageOrContinueEvents(continuation, eventActionResponse);
        this.piping.parameters.systems.setValue('CurrentLanguage', eventActionResponse.LanguageCode);
    };

    LanguageCommand.prototype.refreshPageOrContinueEvents = function (continuationFunc, eventActionResponse) {
        if (!eventActionResponse.RefreshPage)
            continuationFunc();
        else {
            var params = $.extend({}, queryString.getParameters());
            document.location.href = this.piping.url.prepare('', params);
        }
    };

    return LanguageCommand;
});
